var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingcartBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 22.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM18 22.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM21 5.25H4.365L3.75 2.1A.75.75 0 0 0 3 1.5H0V3h2.385L5.25 17.4A.75.75 0 0 0 6 18h13.5v-1.5H6.615L6 13.5h13.5a.75.75 0 0 0 .75-.585l1.5-6.75A.751.751 0 0 0 21 5.25zM18.9 12H5.715l-1.05-5.25h15.398L18.9 12z",
    fill: "#020002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingcartBlack);
export default __webpack_public_path__ + "static/media/shoppingcart_black.403fe915a38b52d3f486c5fe85a9668c.svg";
export { ForwardRef as ReactComponent };